import { IconButton, IconButtonProps } from "@chakra-ui/react"
import { useVoiceSearch } from "@hooks/search/useVoiceSearch"
import { detect } from "detect-browser"
import { Dispatch, SetStateAction, useEffect } from "react"
import { MdMic } from "react-icons/md"

type VoiceSearchProps = IconButtonProps & {
  query: string
  setSearchQuery: Dispatch<SetStateAction<string>>
}

const VoiceSearch = ({ query, setSearchQuery, ...props }: VoiceSearchProps) => {
  const {
    isBrowserSupported,
    isListening,
    toggleListening,
    voiceListeningState,
  } = useVoiceSearch({
    language: "en-AE",
  })

  const browser = detect()

  useEffect(() => {
    if (voiceListeningState.transcript) {
      setSearchQuery(voiceListeningState.transcript)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [voiceListeningState.transcript])

  if (
    !isBrowserSupported ||
    query ||
    (browser && browser.type === "browser" && browser.name !== "chrome")
  ) {
    return null
  }
  return (
    <IconButton
      icon={<MdMic />}
      variant={"ghost"}
      onClick={() => {
        if (!isListening) toggleListening()
      }}
      _hover={{ bg: "transparent" }}
      {...props}
    />
  )
}
export default VoiceSearch
